
import _find from 'lodash-es/find';
import _toLower from 'lodash-es/toLower';

import { Component, Input, AfterContentInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { Chips } from 'primeng/chips';
import { DomHandler } from 'primeng/dom';
import { faTimesCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export const CHIPS_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ChipsTab),
  multi: true
};

@Component({
    selector: 'p-chipstab',
    templateUrl: './chipstab.html',
    styles: [`
        p-chipstab ::ng-deep .ui-chips-input-token input {
            height: auto;
            border: 0;
            padding: .5em .25em;
        }
        .ui-custom-chips {
            display: inline-block !important;
            width: max-content !important;
        }
        .ui-custom-chips-input {
            display: inline-block !important;
            width: 50px !important;
        }
        .ui-custom-ul {
            height: 45px !important;
            overflow-y: scroll;
        }
    `],
    providers: [DomHandler, CHIPS_VALUE_ACCESSOR]
})
export class ChipsTab extends Chips implements AfterContentInit,ControlValueAccessor {
    @Input() public excludeValue: any;

    @Input()
    public osmanClass: boolean;

    public iconClose: IconDefinition = faTimesCircle;

    public onKeydown(event: KeyboardEvent): void {
        const inputEL = this.inputViewChild.nativeElement;

        switch(event.which) {
            //backspace
            case 8:
                if(inputEL.value.length === 0 && this.value && this.value.length > 0) {
                    const removedItem = this.value.pop();
                    this.onModelChange(this.value);
                    this.onRemove.emit({
                        originalEvent: event,
                        value: removedItem
                    });
                }
            break;

            //enter
            case 13:
                this.value = this.value||[];
                if(inputEL.value && inputEL.value.trim().length && (!this.max||this.max > this.value.length)) {
                    event.preventDefault();

                    if(this.isNewValue(inputEL.value)){
                        this.value.push(inputEL.value);
                        this.onModelChange(this.value);
                        this.onAdd.emit({
                            originalEvent: event,
                            value: inputEL.value
                        });
                    }
                }
                inputEL.value = '';
            break;
            //tab
            case 9:
                this.value = this.value || [];
                if(inputEL.value && inputEL.value.trim().length && (!this.max||this.max > this.value.length)) {
                    // event.preventDefault();

                    if(this.isNewValue(inputEL.value)){
                        this.value.push(inputEL.value);
                        this.onModelChange(this.value);
                        this.onAdd.emit({
                            originalEvent: event,
                            value: inputEL.value
                        });
                    }
                    // event.preventDefault();
                }
                inputEL.value = '';
            break;

            default:
                if(this.max && this.value && this.max === this.value.length) {
                    event.preventDefault();
                }
            break;
        }
    }

    /**
     * test if this value is not excluded
     *
     **/
    public isNewValue(_value: string){
        //if this value is in excludedValues
        if(this.excludeValue &&  _find(this.excludeValue, (_v:any) =>_toLower(_value) === _toLower(_v))){
            return false;
        //else if the value has already been typed
    }else if(_find(this.value, (_v:any) =>_toLower(_value) === _toLower(_v))){
            return false;
        }
        //if not, can be added
        return true;
    }

}
